module.exports = __webpack_public_path__ + "static/media/webroll01.5eaab665.mp4";